import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { withStyles } from "@material-ui/core/styles";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import JqxLoader from "jqwidgets-scripts/jqwidgets-react-tsx/jqxloader";
import JqxDateTimeInput from "jqwidgets-scripts/jqwidgets-react-tsx/jqxdatetimeinput";
import * as Util from "../../utils/util.js";
import BasicBackBoard from "../../components/BasicBackBoard";
import AutoCompleteInputTextField from "../../components/AutoCompleteInputTextField.js";

import PqGrid from "../../components/PqGrid";

const CssTextField = withStyles({
  root: {
    "& label.Mui-focused": {
      color: "#ABADB3",
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "green",
    },
    "& .MuiOutlinedInput-root": {
      backgroundColor: "white !important",
      borderRadius: "2px",
      fontFamily: `"Malgun Gothic", "맑은 고딕", AppleSDGothicNeo-Light, sans-serif`,
      "& fieldset": { color: "#ABADB3" },
      "&.Mui-focused fieldset": {
        borderColor: "rgba(0, 176, 246, 1)",
      },
    },
    "& .MuiOutlinedInput-input": {
      fontSize: "13px",
      paddingLeft: "6px",
      paddingRight: "6px",
    },
    "& .MuiIconButton-root": {
      padding: "1px",
      margin: "0px 2px",
    },
  },
})(TextField);

const useStyles = makeStyles(() => ({
  root: { flex: 1, width: "100%", marginTop: "0px" },

  spanVerticalAlign: {
    lineHeight: "26px",
  },

  clearIcon: {
    position: "relative",
    float: "right",
    left: "-620px",
    zIndex: 2,
  },

  cellStyle: { border: "1px solid" },

  textField: {
    width: "200px",
  },

  numberTextField: {
    fontSize: "14px",
    width: "60px",
    height: "26px",
  },

  span: {
    display: "inline-block",
    paddingTop: "3px",
    fontFamily: `"Malgun Gothic", "\B9D1\C740 \ACE0\B515", AppleSDGothicNeo-Light, sans-serif`,
    color: "#4e545f",
    fontWeight: "bold",
    fontSize: "12px",
    lineHeight: "1.5em",
    whiteSpace: "nowrap",
    overflowX: "clip",
    marginLeft: "20px",
  },

  span2: {
    fontFamily: `"Malgun Gothic", "\B9D1\C740 \ACE0\B515", AppleSDGothicNeo-Light, sans-serif`,
    color: "#4e545f",
    fontWeight: "bold",
    fontSize: "12px",
    lineHeight: "1.5em",
    whiteSpace: "nowrap",
    overflowX: "clip",
    marginLeft: "10px",
    display: "inline-block",
  },

  datePicker: {
    width: "165px",
    margin: 0,
    padding: 0,
    fontSize: "1px",
  },

  header: {
    width: "100%",
    marginTop: "10px",
    height: "35px",
    fontFamily: "NanumGothic",
  },

  footer: {
    position: "fixed",
    width: "100%",
    height: "35px",
    backgroundColor: "#DADADA",
    color: "white",
    bottom: 0,
  },

  requestPicture: {
    position: "fixed",
    width: "1201px",
    height: "911px",
    top: 5,
    left: 5,
    backgroundColor: "white",
    border: "3px solid",
    zIndex: 999,
  },
}));

function Menu2(props) {
  const classes = useStyles();
  const myLoader = useRef();
  const myCalendarF = useRef();
  const myCalendarT = useRef();
  const thickF = useRef();
  const thickT = useRef();
  const widthF = useRef();
  const widthT = useRef();
  const lengthF = useRef();
  const lengthT = useRef();
  const [itemList, setItemList] = useState([]);
  const [culture, setCulture] = useState("ko-KR");
  const refSearchSellCust = useRef();
  const refSearchVenCust = useRef();
  const refSearchDlvCust = useRef();
  const refSearchName = useRef();
  const refSearchStan = useRef();
  const refMillNo = useRef();

  const refPqGrid = useRef(null);
  const [onDisplay, setOnDisplay] = useState(false);

  useEffect(() => {
    if (props.name === props.selected) {
      setOnDisplay(true);
    } else {
      setOnDisplay(false);
    }
  }, [props.name, props.selected]);

  const columnLayout = [
    {
      title: "작업번호",
      dataIndx: "JOB_NO",
      width: 100,
      styleHead: { "text-align": "center" },
      style: {},
      editable: false,
      merge: true,
    },
    {
      title: "소재번호",
      dataIndx: "MT_COIL_NO",
      width: 200,
      editable: false,
      styleHead: { "text-align": "center" },
      style: {},
      merge: true,
    },
    {
      title: "투입사이즈",
      dataIndx: "MT_SIZE_NO",
      width: 120,
      editable: false,
      styleHead: { "text-align": "center" },
    },
    {
      title: "투입중량",
      dataIndx: "MT_WEIGHT",
      width: 100,
      editable: false,
      styleHead: { "text-align": "center" },
      style: {
        "font-size": "14px",
      },
      dataType: "float",
      format: "#,##0.0",
    },
    {
      title: "생산일",
      dataIndx: "PROD_DATE",
      width: 100,
      editable: false,
      styleHead: { "text-align": "center" },
      style: { "text-align": "center", "font-size": "14px" },
    },
    {
      title: "품명",
      dataIndx: "MT_NAME_NAME",
      width: 80,
      editable: false,
      styleHead: { "text-align": "center" },
      style: {},
    },
    {
      title: "재질",
      dataIndx: "MT_STAN_NAME",
      width: 130,
      editable: false,
      styleHead: { "text-align": "center" },
      style: {},
    },
    {
      title: "투입수량",
      dataIndx: "MT_QUANTITY",
      width: 95,
      editable: false,
      styleHead: { "text-align": "center" },
      style: { "font-size": "14px" },
      dataType: "float",
      format: "#,##0",
    },
    {
      title: "유형",
      dataIndx: "TYPE_NAME",
      width: 80,
      editable: false,
      styleHead: { "text-align": "center" },
      style: {},
    },
    {
      title: "사이즈",
      dataIndx: "SIZE_NO",
      width: 100,
      editable: false,
      styleHead: { "text-align": "center" },
    },
    {
      title: "수량",
      dataIndx: "QUANTITY",
      width: 70,
      editable: false,
      styleHead: { "text-align": "center" },
      style: { "font-size": "14px" },
      dataType: "float",
      format: "#,##0",
      summary: { type: "sum" },
    },
    {
      title: "중량",
      dataIndx: "WEIGHT",
      width: 100,
      editable: false,
      styleHead: { "text-align": "center" },
      style: { "font-size": "14px" },
      dataType: "float",
      format: "#,##0",
      summary: { type: "sum" },
    },
    {
      title: "포장번호",
      dataIndx: "PACK_NO",
      width: 140,
      editable: false,
      styleHead: { "text-align": "center" },
      style: {},
    },
    {
      title: "수요가",
      dataIndx: "SELL_CUST_NAME",
      width: 200,
      editable: false,
      styleHead: { "text-align": "center" },
      style: {},
    },
    {
      title: "사급업체",
      dataIndx: "VEN_CUST_NAME",
      width: 200,
      editable: false,
      styleHead: { "text-align": "center" },
      style: {},
    },
    {
      title: "착지",
      dataIndx: "DLV_CUST_NAME",
      width: 200,
      editable: false,
      styleHead: { "text-align": "center" },
      style: {},
    },
    {
      title: "제품번호",
      dataIndx: "COIL_NO",
      width: 140,
      editable: false,
      styleHead: { "text-align": "center" },
      style: {},
    },
  ];

  const loadItem = () => {
    myLoader.current.open();

    axios
      .get(Util.getBaseUrl() + "Menu2/retrieve", {
        params: {
          isOutSider: Util.isOutsider(),
          dateF: new Date(
            myCalendarF.current.getDate() -
              new Date().getTimezoneOffset() * 60000
          )
            .toISOString()
            .substring(0, 10)
            .replaceAll("-", ""),
          dateT: new Date(
            myCalendarT.current.getDate() -
              new Date().getTimezoneOffset() * 60000
          )
            .toISOString()
            .substring(0, 10)
            .replaceAll("-", ""),
          userId: window.sessionStorage.getItem("user_id"),
          myCustCd: window.sessionStorage.getItem("workplace_cd"),
          sellCustCd: refSearchSellCust.current.get().code,
          sellCustName: refSearchSellCust.current.get().input,
          venCustCd: refSearchVenCust.current.get().code,
          venCustName: refSearchVenCust.current.get().input,
          dlvCustCd: refSearchDlvCust.current.get().code,
          dlvCustName: refSearchDlvCust.current.get().input,
          nameName: refSearchName.current.get().input,
          stanName: refSearchStan.current.get().input,
          nameCd: refSearchName.current.get().code,
          stanCd: refSearchStan.current.get().code,
          thickF: thickF.current.value,
          thickT: thickT.current.value,
          widthF: widthF.current.value,
          widthT: widthT.current.value,
          lengthF: lengthF.current.value,
          lengthT: lengthT.current.value,
          millNo: refMillNo.current.get().input,
        },
      })
      .then((response) => {
        if (response.data.code === "0") {
          myLoader.current.close();
          let res = response.data;
          setItemList(res.data);
        } else {
          alert(
            "조회된 내역이 없습니다.",
            myLoader.current.close(),
            setItemList([])
          );
        }
      })
      .catch((e) => {
        console.error(e); // 에러표시
        myLoader.current.close();
      });
  };

  return (
    <div style={{ width: "100%", height: "100%", overflowY: "hidden" }}>
      <div
        style={{
          display: "flex",
          height: "100%",
          flexDirection: "column",
          flex: 1,
        }}
      >
        <BasicBackBoard minHeight={"60px"}>
          <div style={{ flex: "0 0 auto" }}>
            <div className="d-flex p-1 pb-0 search-form-div">
              <div>
                <span className={classes.span}>생산일</span>
              </div>
              <div className="ms-2" onKeyDown={Util.enterToFocusMove}>
                <JqxDateTimeInput
                  textAlign="center"
                  ref={myCalendarF}
                  animationType={"none"}
                  formatString={"yyyy-MM-dd"}
                  culture={culture}
                  width={130}
                  height={"26px"}
                />
              </div>
              <div className="mx-1 px-1">
                <object className={classes.spanVerticalAlign}>~</object>
              </div>
              <div onKeyDown={Util.enterToFocusMove}>
                <JqxDateTimeInput
                  textAlign="center"
                  ref={myCalendarT}
                  animationType={"none"}
                  culture={culture}
                  formatString={"yyyy-MM-dd"}
                  width={130}
                  height={"26px"}
                />
              </div>
              <div style={{ display: Util.isOutsider() ? "none" : "flex" }}>
                <div>
                  <span className={classes.span}>수요가 </span>
                </div>
                <div className="ms-2">
                  <AutoCompleteInputTextField
                    ref={refSearchSellCust}
                    lists={JSON.parse(
                      window.sessionStorage.getItem("sellCustCd")
                    )}
                  />
                </div>
              </div>
              <div style={{ display: Util.isOutsider() ? "none" : "flex" }}>
                <div>
                  <span className={classes.span}>사급업체</span>
                </div>
                <div className="ms-2">
                  <AutoCompleteInputTextField
                    ref={refSearchVenCust}
                    lists={JSON.parse(
                      window.sessionStorage.getItem("sellCustCd")
                    )}
                  />
                </div>
              </div>
              <div style={{ display: Util.isOutsider() ? "none" : "flex" }}>
                <div>
                  <span className={classes.span}>착지</span>
                </div>
                <div className="ms-2">
                  <AutoCompleteInputTextField
                    ref={refSearchDlvCust}
                    lists={JSON.parse(
                      window.sessionStorage.getItem("sellCustCd")
                    )}
                  />
                </div>
              </div>
            </div>
            <div className="d-flex mt-2 px-0 py-1 search-form-div">
              <div style={{ marginLeft: "14px" }}>
                <span className={classes.span}>품명</span>
              </div>
              <div className="ms-2 hidden-form">
                <AutoCompleteInputTextField
                  ref={refSearchName}
                  lists={JSON.parse(window.sessionStorage.getItem("code_nm"))}
                  width={100}
                />
              </div>
              <div style={{ marginLeft: "1px" }}>
                <span className={classes.span}>재질</span>
              </div>
              <div className="ms-2">
                <AutoCompleteInputTextField
                  ref={refSearchStan}
                  lists={JSON.parse(window.sessionStorage.getItem("code_stan"))}
                  width={140}
                />
              </div>
              <div style={{ marginLeft: "2px" }}>
                <span className={classes.span}>두께</span>
              </div>
              <div className="ms-2">
                <CssTextField
                  onKeyDown={Util.enterToFocusMove}
                  placeholder="0.0"
                  size="small"
                  inputRef={thickF}
                  variant="outlined"
                  className={classes.numberTextField}
                  inputProps={{
                    inputMode: "numeric",
                    style: {
                      textAlign: "center",
                      width: "60px",
                      height: "6px",
                      fontSize: "14px",
                    },
                    autoComplete: "one-time-code",
                  }}
                />
              </div>
              <div className="mx-1 px-1">
                <object className={classes.spanVerticalAlign}>~</object>
              </div>
              <div>
                <CssTextField
                  onKeyDown={Util.enterToFocusMove}
                  placeholder="0.0"
                  inputRef={thickT}
                  size="small"
                  className={classes.numberTextField}
                  variant="outlined"
                  inputProps={{
                    inputMode: "numeric",
                    style: {
                      textAlign: "center",
                      width: "60px",
                      height: "6px",
                      fontSize: "14px",
                    },
                    autoComplete: "one-time-code",
                  }}
                />{" "}
              </div>
              <div style={{ marginLeft: "87px" }}>
                <span className={classes.span}>폭</span>
              </div>
              <div className="ms-2">
                <CssTextField
                  onKeyDown={Util.enterToFocusMove}
                  size="small"
                  inputRef={widthF}
                  placeholder="0.0"
                  variant="outlined"
                  className={classes.numberTextField}
                  inputProps={{
                    inputMode: "numeric",
                    style: {
                      textAlign: "center",
                      width: "60px",
                      height: "6px",
                      fontSize: "14px",
                    },
                    autoComplete: "one-time-code",
                  }}
                />
              </div>
              <div className="mx-1 px-1">
                <object className={classes.spanVerticalAlign}>~</object>
              </div>
              <div>
                <CssTextField
                  onKeyDown={Util.enterToFocusMove}
                  placeholder="0.0"
                  inputRef={widthT}
                  size="small"
                  className={classes.numberTextField}
                  variant="outlined"
                  inputProps={{
                    inputMode: "numeric",
                    style: {
                      textAlign: "center",
                      width: "60px",
                      height: "6px",
                      fontSize: "14px",
                    },
                    autoComplete: "one-time-code",
                  }}
                />
              </div>
              <div style={{ marginLeft: "52px" }}>
                <span className={classes.span}>길이</span>
              </div>
              <div className="ms-2">
                <CssTextField
                  onKeyDown={Util.enterToFocusMove}
                  size="small"
                  inputRef={lengthF}
                  placeholder="0.0"
                  variant="outlined"
                  className={classes.numberTextField}
                  inputProps={{
                    inputMode: "numeric",
                    style: {
                      textAlign: "center",
                      width: "60px",
                      height: "6px",
                      fontSize: "14px",
                    },
                    autoComplete: "one-time-code",
                  }}
                />
              </div>
              <div className="mx-1 px-1">
                <object className={classes.spanVerticalAlign}>~</object>
              </div>
              <div>
                <CssTextField
                  onKeyDown={Util.enterToFocusMove}
                  placeholder="0.0"
                  inputRef={lengthT}
                  size="small"
                  className={classes.numberTextField}
                  variant="outlined"
                  inputProps={{
                    inputMode: "numeric",
                    style: {
                      textAlign: "center",
                      width: "60px",
                      height: "6px",
                      fontSize: "14px",
                    },
                    autoComplete: "one-time-code",
                  }}
                />
              </div>
              <div style={{ marginLeft: "38px" }}>
                <span className={classes.span}>소재번호</span>
              </div>
              <div className="ms-2">
                <AutoCompleteInputTextField
                  ref={refMillNo}
                  lists={[]}
                  width={90}
                />
              </div>
              <div className="d-flex" style={{ marginLeft: "38px" }}>
                <Button
                  className="d-btn primary"
                  onClick={() => loadItem()}
                  variant="contained"
                >
                  조회
                </Button>
                <Button
                  className="d-btn primary"
                  onClick={() => {
                    refPqGrid.current?.exportExcel("생산현황");
                    Util.setMonitoring(
                      window.sessionStorage.getItem("user_id"),
                      "생산현황",
                      "엑셀"
                    );
                  }}
                  variant="contained"
                >
                  엑셀
                </Button>
              </div>
            </div>
          </div>
        </BasicBackBoard>
        <div className={classes.root}>
          <PqGrid
            name={props.name}
            ref={refPqGrid}
            width={"100%"}
            columns={columnLayout}
            dataModel={itemList}
            display={onDisplay}
            retrieve={loadItem}
          />
          <JqxLoader ref={myLoader} width={100} height={60} />
        </div>
      </div>
    </div>
  );
}

export default React.memo(Menu2);
